import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  customButtonWrapper: {
    minWidth: 151,
    height: 40,
    borderRadius: theme.app.borderRadius.md,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    padding: theme.app.spacing.sm,

    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.subTitle.fontSize,

    backgroundColor: theme.palette.primary.main,
    border: 'none',
    color: theme.palette.text.primary,
    fontWeight: 600,
    cursor: 'pointer'
  },

  outlinedButtonWrapper: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  customButtonDisabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  },

  content: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease'
  },

  loader: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))
